import axiosWithInterceptor from "@/config/Others/axiosWithInterceptor";
import axios from "axios";

export async function getActivitiesHome() {
  try {
    const response = await axiosWithInterceptor.get("v1/activities/featured");
    if (response) {
      return response;
    }
  } catch (error) {
    // console.error(error);
    throw error;
  }
}

export const fetchHotelTypes = async () => {
  // Proxy público para evitar CORS
  const proxy  = 'https://api.allorigins.win/raw?url=';
  const target = `${process.env.NEXT_PUBLIC_ROYAL_URL}resources/hotel_types.json`;
  const url    = proxy + encodeURIComponent(target);
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Error al cargar los datos');
  }
  return await response.json();
};
